<template>
    <div class="ui-popover-section">
        <slot></slot>
    </div>
</template>
